(function($) {

  $.Control.extend(
    'pane_filterDisabled',
    {
      isAvailable: function() {
        return true;
      },

      getTitle: function() {
        return $.t('screens.ds.grid_sidebar.filter_disabled.title');
      },

      getSubtitle: function() {
        return $.t('screens.ds.grid_sidebar.filter_disabled.subtitle');
      },

      getDisabledSubtitle: function() {
        return '';
      },

      _getSections: function() {
        return [];
      },

      _getFinishButtons: function() {
        return [];
      },

      // Arguments provided to this method: 'data', 'value', 'finalCallback'
      _finish: function() {}
    },
    { name: 'filterDisabled' },
    'controlPane'
  );

  $(document).ready(function() {
    var showPane = _.get(window, 'socrata.gridView.sidebarPaneVisibility.filter.filterDisabled', false);

    if (showPane) {
      $.gridSidebar.registerConfig('filter.filterDisabled', 'pane_filterDisabled', 1);
    }
  });
})(jQuery);
